import {React} from 'react';

export default function Contenu({champ}) {
    return (
        <p className="mb-0" dangerouslySetInnerHTML={{__html: champ.libelle}}></p>
    )
}